<template>
    <div class="width-container">
        <div id="project-links" >
            <h2 class="projects-title">Please enjoy this unordered<br/>list of projects:</h2>
            <ul>
                <!-- <li v-for="project in projects" 
                    :key="project.id" 
                    @mouseover="lazyLoadContent($event.target)">
                    <div class="title" ref="projectsTitle">
                        <a :href="'#' + toKebab(project.title)" 
                           @focus="lazyLoadContent($event.target)"
                           @click="onClick($event)"
                           tabindex="0">
                                <h3>{{project.title}}</h3>
                        </a>
                        <button class="close" 
                                @click="onClick($event)"
                                :tabindex="detailsOpen ? 0 : -1">
                        <img :src="require(`../assets/close.svg`)" :alt="`Close ${project.title}`" />
                        </button>
                    </div>
                    <div class="details">
                        <div class="description">
                            <div v-for="subsection in project.description" :key="subsection.id">
                                <h4 v-if="subsection.title" v-html="subsection.title"></h4>
                                <h5 v-if="subsection.subtitle" v-html="subsection.subtitle"></h5>
                                <p v-for="paragraph in subsection.text" :key="paragraph.id" v-html="paragraph"></p>
                            </div>
                        </div>
                        <image-gallery :content="project.images" />
                    </div>
                </li> -->
                <project-list-item 
                    v-for="project, index in projects"
                    :key="project.id" 
                    :project="project"
                    :liIndex="index"
                    @openListItem="open($event)">
                </project-list-item>
            </ul>
        </div>
    </div>
</template>

<script>

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import projectData from "../content/projects.json";
import ProjectListItem from '../components/ProjectListItem.vue'


export default {
  name: 'Projects',
  components: {
    ProjectListItem
  },
  data() {
    return {
      projects: projectData,
      detailsOpen: false,
      activeTl: gsap.timeline({}),
    };
  },
  methods: {
    createOpenTimeline(listItem){
        listItem.classList.add('active'); 
        this.detailsOpen = true;
        let originalHeight = gsap.getProperty(".projects-title", "height") + 
                             gsap.getProperty("#project-links ul", "height") + 
                             gsap.getProperty("#project-links li:first-child", "marginTop");
        let title = document.querySelector('.projects-title');
        let getItemHeight = ()=> { return listItem.clientHeight + listItem.querySelector(".details").clientHeight};
        let offset = (window.innerHeight - listItem.clientHeight)/2;
        
        const pt = title.getBoundingClientRect();
        const pt2 = listItem.getBoundingClientRect();
        let showDetails = gsap.timeline({
            paused: true,
            onStart: ()=> { gsap.to(window, {duration: .75, scrollTo: {y: "#project-links", offsetY: offset}}) },
            onReverseComplete: ()=> {
                ScrollTrigger.getById("section2").animation.invalidate();
                ScrollTrigger.getById("detailsSection").animation.invalidate();
                gsap.to(window, {duration: .05, scrollTo: {y: "+=1"}})
            }
        })        
        showDetails.to('body, .pin-spacer-section2pin', {
                        backgroundColor: '#2f2068', 
                        immediateRender: false, 
                        onComplete: ()=> { this.$parent.detailsOpen = true }, 
                        onReverseComplete: ()=> {this.$parent.detailsOpen = false}}, "start")
                   .to(listItem, { y: ()=> pt.y - pt2.y + (window.innerWidth < 400 ? 40 : 25), ease: "sine.out", duration: (Math.abs(pt.y - pt2.y)*.0011).toFixed(2)}, "start")
                   .to('.projects-title', {duration: .35, scale: .8, autoAlpha: 0}, "start")
                   .to('#project-links li:not(.active)', {x: "5%", autoAlpha: 0, stagger: {each: .05, from: "end"}, duration: .2, onReverseComplete: ()=> {
                        document.querySelectorAll("#project-links .active").forEach((item)=>{item.classList.remove('active')}); 
                        this.detailsOpen = false;
                   }}, "start")
                   .fromTo('#project-links', {height: originalHeight}, {
                        duration: .25,
                        height: ()=> getItemHeight(),
                    }, ">") 
                   .to('#project-links', {
                        duration: .25,
                        x: this.isMobile() ? "5%" : "-25%" , 
                        z: 0,
                    }, ">")
                    .to('#project-links li.active .details', {autoAlpha: 1, duration: .25, 
                        onStart: ()=> {
                            listItem.classList.add('showDetails')
                            this.$root.$emit('toggleBodyPath', listItem);
                        },
                        onReverseComplete: ()=> {
                            listItem.classList.remove('showDetails')
                            this.$root.$emit('toggleBodyPath', listItem)
                        }
                    }, "<")
                    .fromTo('#project-links li.active .close', {autoAlpha: 0, scale: 0}, {autoAlpha: 1, scale: 1, duration: .25, transformOrigin: "center", ease: "back.out"}, "<")
        
        return showDetails;    
    },
    open(e) {
        let listItem = e.target.closest("li");
        if (this.detailsOpen) {  
            this.activeTl.reverse(); 
            return;
        }
        this.activeTl = this.createOpenTimeline(listItem)
        this.activeTl.play()
    },
  },
  mounted() {
    window.addEventListener("keyup", (e)=> {
        if (e.key === "Escape" && this.$parent.fullScreenOpen === false) {
            if (this.detailsOpen) { this.activeTl.reverse(); }
        }
    });
    ScrollTrigger.addEventListener("refreshInit", ()=> {
        if (this.detailsOpen) {
            let activeItem = document.querySelector("li.active");
            activeItem.classList.remove("showDetails");
            activeItem.classList.remove("active");
            this.detailsOpen = false;
            this.activeTl.revert();
        }
    })
  }
}
</script>

<style lang="less" >
[data-whatintent='keyboard'] {
  #project-links ul li:not(.active) .title a:focus, .section-5 a.email:focus, .details .description a:focus {
    border-radius: 4px;
    outline: solid 6px #9EFFED;
    background: #9EFFED;
    outline-offset: 0px;
    color: #2f2068!important;
    span { color: inherit}
  }
  #project-links li .details .live-link:focus:after {
    content: url('~@/assets/arrow-right_purple.svg');
  }
  #project-links ul li .title .close:focus{
    box-shadow: #9fffee 0px 0px 30px 5px, #9fffee 0px 0px 0px 3px;
  }
}
.section-3 {
    overflow: visible;
    position: relative;
    .width-container {
        height: 100%;
    }
}
#project-links {
    position: relative;
    overflow: visible;
    transform: translateX(5%) translateZ(0);
    @media (min-width: 400px) {
        transform: translateX(15%) translateZ(0);
    }
    .projects-title {
        color: #ff779c; 
        //color: #5934B4;
        font-family: 'Righteous'; 
         @media (min-width: 400px) {
            padding-bottom: 15px;
         }
    }
    ul {
        list-style: none;
        margin: 0;
        padding: 0;
        width: 100%;
        @media (min-width: 800px) {
            width: 200%;
        }
    }
}
</style>
